import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <TopicsSection />
        <CommentsSection />
        <CarouselSection />
        <FeaturesSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <IndexSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}